import React from 'react';
import AuthContainer from '../../containers/auth/AuthContainer';

const AuthPage = props => {
	return <AuthContainer {...props} />;
};

export default AuthPage;
